import { DefaultCapexOpexEstNames } from './default-capex-opex-est-names.enum';

export class DefaultCapexEstPercentages {
  static DEFAULT_CAPEX_EST_PERCENTAGES = {
    [DefaultCapexOpexEstNames.LABOR]: 10.895884,
    [DefaultCapexOpexEstNames.UPGRADING_UNIT]: 10.895884,
    [DefaultCapexOpexEstNames.SERVICES]: 3.389831,
    [DefaultCapexOpexEstNames.INSURANCE]: 3.389831,
    [DefaultCapexOpexEstNames.TAXES]: 2.663438,
    [DefaultCapexOpexEstNames.PH_CONTROL]: 0.484262,
    [DefaultCapexOpexEstNames.OTHER]: 2.421308
  };
}
